// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__P4MjN","errors":"Errors_errors__9SdWQ"};